import GiftFreeTrialModal from "@/Components/UI/Modals/GiftFreeTrialModal";
import { ChatPageProps } from "@/Pages/Chat/Chat";
import { usePage } from "@/utils/turboSafeInertia";
import axios from "axios";
import { PropsWithChildren, useEffect, useState } from "react";
import { GiftCoachingContext } from "./GiftCoachingContext";

export function GiftCoachingProvider({ children }: PropsWithChildren) {
    const { user } = usePage<ChatPageProps>().props;

    const [showGiftFreeTrialModal, setShowGiftFreeTrialModal] = useState(false);
    const [canDoReferrals, setCanDoReferrals] = useState(false);

    const fetchCanDoReferrals = async () => {
        try {
            const response = await axios.get(
                route("referral-program.client-can-do-referrals"),
            );
            const data = response.data as { canDoReferrals: boolean };
            setCanDoReferrals(data.canDoReferrals);
        } catch (error) {
            console.error("Error fetching canDoReferrals:", error);
        }
    };

    useEffect(() => {
        if (user?.type !== "client" && showGiftFreeTrialModal) {
            setShowGiftFreeTrialModal(false);
        }
        if (user?.type === "client" && user?.email_verified_at) {
            fetchCanDoReferrals();
        }
    }, [user?.type, user?.email_verified_at, showGiftFreeTrialModal]);

    return (
        <GiftCoachingContext.Provider
            value={{
                showGiftCoachingModal: () => setShowGiftFreeTrialModal(true),
                canDoReferrals: canDoReferrals,
            }}
        >
            <GiftFreeTrialModal
                showModal={showGiftFreeTrialModal}
                onRequestClose={() => setShowGiftFreeTrialModal(false)}
            />
            {children}
        </GiftCoachingContext.Provider>
    );
}
